import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import DataTable from "../../Student/Reusablecomponents/DataTable/DataTable";
import Loading from "../../Student/Reusablecomponents/Loading";
import { format } from "date-fns";
import { RiFileExcel2Fill } from "react-icons/ri";
import { DownloadExcel } from "../../ReusableComponents/CommonFunctions";
import { GetQBAdminUsers } from "../../ReusableComponents/NCLAdminDropdowns";
import axiosInstance from "../../ReusableComponents/Axios";
import { useSelector } from "react-redux";
import notify from "../../ReusableComponents/ToastifyAlerts";
const QBAQuestionStatusTrack = () => {
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const [subjectId, setSubjectId] = useState(items?.subjectId);
  const [Load, SetLoad] = useState(false);
  const [QuestionTrack, SetQuestionTrack] = useState([]);
  const [questionType, setQuestionType] = useState("1");
  // const [monday, setMonday] = useState('');
  // const [sunday, setSunday] = useState('');
  const [PweekDates, SetPweekDates] = useState();
  const [PageCount, SetPageCount] = useState(10);
  const [CPage, SetCPage] = useState(1);
  const subjects = {
    1: "Mathematics",
    2: "Science",
    3: "English",
  };

  const [SelectDateType, SetSelectDateType] = useState("CM");
  const [StartDate, SetStartDate] = useState(new Date().toISOString().split("T")[0]);
  const [EndDate, SetEndDate] = useState("");
  // const [SelectUsers, SetSelectUsers] = useState([]);
  const OverallQuestionStatusTrack = async (PageNo) => {
    if (SelectDateType === "CD" && StartDate && !EndDate) {
      notify("Please select End date", "warning");
    } else {
      SetQuestionTrack([]);
      SetCPage(PageNo);
      SetLoad((prev) => !prev);
      try {
        const response = await axiosInstance.get(
          `/NCLAdmin/GetOverallQuestionsTrack?SubjectId=${items?.subjectId}&pageno=1&pagesize=${PageCount}&pagination=0&DateFilter=${SelectDateType}&UserId=${items?.userId}&StartDate=${StartDate}&EndDate=${EndDate} `,
        );
        SetLoad((prev) => !prev);
        SetQuestionTrack(response.data);
      } catch (error) {
        console.error("Error fetching Questions data:", error);
        return [];
      }
    }
  };
  useEffect(() => {
    // SelectUsers.length > 0 && 
    if ((SelectDateType !== "SD" && SelectDateType !== "CD")) {
      OverallQuestionStatusTrack();
    }
  }, [questionType, SelectDateType]);

  const OverAllColumns = [
    { name: "Grade", selector: "grade", sortable: true, },
    { name: "CBSE / SCERT Chapter No", selector: "chapterNo", sortable: false, cell: (row) => (row.chapterNo === 0 ? "" : row.chapterNo), },
    ...(items?.subjectId == 1
      ? [
        { name: "Content", selector: "content", sortable: true, },
      ]
      : []),
    ...(items?.subjectId === 3 ? [{ name: "Book", selector: "book", sortable: true }] : []),

    ...(items?.items?.subjectId !== 3 ? [{ name: "Topic", selector: "topic", sortable: true, },
    { name: "Subtopic", selector: "subTopic", sortable: true, },] : []),
    { name: "Learning Outcome", selector: "learningOutcome", sortable: true },
    ...(items?.items?.subjectId !== 3 ? [
      { name: "Sub-Learning Outcome", selector: "subLO", sortable: true, },
      { name: "NCERT Learning Outcome", selector: "ncertlo", sortable: true, },
    ] : []),
    { name: "Source", selector: "source", sortable: true, },
    { name: "ScenarioID", selector: "scenarioID", sortable: true, cell: (row) => (row.scenarioID === 0 ? "" : row.scenarioID), },
    { name: "QuestionID", selector: "questionID", sortable: false, },
    { name: "QB creator name", selector: "qbCreator", sortable: true },
    { name: "Created Date", selector: "createdDate", sortable: true, cell: (row) => row.createdDate ? format(new Date(row.createdDate), "dd-MM-yyyy") : "", },
    { name: "QB Status", selector: "qcStatus", sortable: true },
    { name: "QC done by ", selector: "qcDoneBy", sortable: true, },
    { name: "QC Completion Date", selector: "qcCompletionDate", sortable: true, cell: (row) => row.qcCompletionDate ? format(new Date(row.qcCompletionDate), "dd-MM-yyyy") : "", },
    ...(items?.subjectId == 1
      ? [
        { name: "Cloned/Original", selector: "clonedorOriginal", sortable: true, },
      ]
      : []),
    { name: "Alignment of Items with Standard", selector: "alignmentofItemswithStandard", sortable: true, },
    { name: "Stem of Question", selector: "stemofquestion", sortable: true, },
    { name: "MCQs Options", selector: "mcQsOptions", sortable: true, },
    { name: "Item Bias and Sensitivity Issues", selector: "itemBiasandSensitivityIssues", sortable: true, },
    { name: "Image Quality and Relevance", selector: "imageQualityandRelevance", sortable: true, },
    { name: "Grammar and Layout", selector: "grammarandLayout", sortable: true, },

    ...(items?.subjectId !== 3 ? [
      { name: "Translation date (Using AI)", selector: "createdDate", sortable: true, cell: (row) => row.createdDate ? format(new Date(row.createdDate), "dd-MM-yyyy") : "", },
      { name: "QC Status of translated question", selector: "qcTranslationStatus ", sortable: true,  },
      { name: "QC Completion Date for translated question", selector: "qcTranslationCompletionDate", sortable: true,cell: (row) => row.qcTranslationCompletionDate ? format(new Date(row.qcTranslationCompletionDate), "dd-MM-yyyy") : "", },
      { name: "QC Translation done by", selector: "qcTranslationDoneBy", sortable: true, },
      { name: "Type of Issue", selector: "typeOfIssue", sortable: true, },
    ] : []),



  ];

  const DownloadOverallQuestionsTrack = () => {
   if (SelectDateType === "SD" || SelectDateType === "CD") {
      if (!StartDate) {
        notify(`Please select ${SelectDateType === "CD" ? "Start" : ""} date`, "warning");
        return;
      }
      if (!EndDate && SelectDateType !== "SD") {
        {
          notify(`Please select End date`, "warning");
          return;
        }
      }
    }
    if ((QuestionTrack.length <= 1 && QuestionTrack?.[0]?.questionID === 0) || QuestionTrack.length === 0) {
      notify("No data available to download", "info");
      return;
    }
    // const subjectName = subjects[subjectId];
    const XL = QuestionTrack?.map((item, index) => {
      return {
        SNo: index + 1,
        Grade: item.grade,
        "CBSE / SCERT Chapter No": item.chapterNo === 0 ? "" : item.chapterNo,
        ...(items?.subjectId === 1 && { "Content": item?.content }),

        ...(items?.subjectId === 3 && { Book: item.book }),
        ...(subjectId !== 3 && {
          "Topic": item.topic,
          "Subtopic": item?.subTopic,
        }),

        "Learning Outcome": item.learningOutcome,
        ...(subjectId !== 3 && {
          "Sub-Learning Outcome": item.subLO,
          "NCERT Learning Outcome": item?.ncertlo,
        }),
        "Source": item.source,
        ScenarioID: item.scenarioID === 0 ? "" : item.scenarioID,
        "QuestionID	": item.questionID,
        "QB creator name": item.qbCreator,
        "Created Date": item.createdDate,
        "QB Status": item.qcStatus,
        "QC done by": item?.qcDoneBy,
        "QC Completion Date": item.qcCompletionDate,
        ...(items?.subjectId === 1 && { "Cloned/Original": item.clonedorOriginal }),
        "Alignment of Items with Standard": item.alignmentofItemswithStandard,
        "Stem of Question": item?.stemofquestion,
        "MCQs Options": item?.mcQsOptions,
        "Item Bias and Sensitivity Issues": item?.itemBiasandSensitivityIssues,
        "Image Quality and Relevance": item?.imageQualityandRelevance,
        "Grammar and Layout": item?.grammarandLayout,


        ...(subjectId !== 3 && {
          "Translation date (Using AI)": item.createdDate ? format(new Date(item.createdDate), "dd-MM-yyyy") : "",
          "QC Status of translated question":item.qcTranslationStatus ,
          "QC Completion Date for translated questions":item.qcTranslationCompletionDate ? format(new Date(item.qcTranslationCompletionDate), "dd-MM-yyyy") : "" ,
          "QC Translation done by":item?.qcTranslationDoneBy ,
          "Type of Issue": item?.typeOfIssue,
        }),

      };
    });
    DownloadExcel(
      XL,
      `${items?.fullName}_Content_Report_${SelectDateType === "SD" ? QuestionTrack?.[0]?.startEndDate?.split(" ")[0] : QuestionTrack?.[0]?.startEndDate?.replaceAll("/", "-")?.replaceAll(" ", "_")}`,

      // `Overall Question Status Track (${items?.subjectName})`,
      false,
      `Overall Question Status Track (${items?.subjectName})`,
      `Overall Question Status Track (${items?.subjectName})`,
      true
    );
  };

  const SDT = [
    { name: "By Date", value: "SD", },
    { name: "Current Week", value: "CW", },
    { name: "Previous Week", value: "PW", },
    { name: "Current Month", value: "CM", },
    { name: "Previous Month", value: "PM", },
    { name: "Date Range", value: "CD", },
  ];
  const OnChangeDatefilters = (e) => {
    SetStartDate("");
    SetEndDate("");
    SetSelectDateType(e); SetQuestionTrack([]);
  }
  return (
    <div className="TeacherBgImage">
      <div className="dflex alignitems justify-content-between w-100 mt-4">
        <div className="dflex alignitems gap-4">
          <h2 className="SubHeading mb-0">
            Question Status Track {questionType === "0" && `(${PweekDates})`}
          </h2>
        </div>


        <div className="dflex alignitems gap-2">
          <div
            className="ExportExcel dflex alignitems CPointer"
            onClick={() =>
              // questionType === "0"
              //   ? DownloadWeeklyTrack()
              DownloadOverallQuestionsTrack()
            }
            title="Export Excel"
          >
            <RiFileExcel2Fill className="me-2" />
          </div>

        </div>
      </div>
      {questionType !== "0" &&
        <div className="dflex alignitems flexd-column InputFIlters mt-3">
          <label>Filters</label>
          {/* <div className="dflex w-100 alignitems gap-4">
            <GetQBAdminUsers selected={SelectUsers} onChange={(e, r) => StoreQBUsers(e, r)} Storevalue={SetSelectUsers} SUBId={subjectId} />
            {(SelectDateType !== "SD" && SelectDateType !== "CD") && <button className="Buttons" onClick={() => OverallQuestionStatusTrack()}>Go</button>}</div> */}
          <div className="dflex gap-3 alignitems">
            {SDT.map((item) =>
              <div className="dflex gap-1 alignitems">
                <input type="radio" name="dateFilter" value={item?.value} checked={SelectDateType === item?.value} onClick={() => {OnChangeDatefilters(item?.value);}} /> {item?.name}</div>)}</div>

          {(SelectDateType === "SD" || SelectDateType === "CD") &&
            <div className="dflex gap-4 alignitems ">
              <div className="dflex gap-1" >
                <div className="DropdownHeader"> {SelectDateType === "SD" ? "Select" : "Start"} Date : </div>
                <input type="date" className="NCLDropdown" value={StartDate} onChange={(e) => SetStartDate(e.target.value)} max={new Date().toISOString().split("T")[0]} />
              </div>
              {SelectDateType !== "SD" &&
                <div className="dflex gap-1">
                  <div className="DropdownHeader"> End Date : </div>
                  <input type="date" className="NCLDropdown" value={EndDate} onChange={(e) => SetEndDate(e.target.value)} min={StartDate} max={new Date().toISOString().split("T")[0]} />
                </div>}
              <button className="Buttons" onClick={() => OverallQuestionStatusTrack()}>Go</button>
            </div>}
         {QuestionTrack?.length > 0 &&` You have selected ${SDT.find(item => item.value === SelectDateType)?.name} : ${SelectDateType === "SD" ? QuestionTrack?.[0]?.startEndDate?.split(" ")[0] : QuestionTrack?.[0]?.startEndDate}   and count : ${QuestionTrack?.[0]?.questionID <= 0 ? 0 :QuestionTrack?.length}`}

        </div>}
      <DataTable className="NCLDataTable Card mt-3"
        data={QuestionTrack?.[0]?.questionID <= 0 ? []: QuestionTrack}
        columns={OverAllColumns}
        // columns={questionType !== "0" ? OverAllColumns : Columns}
        CountPage={SetPageCount}
        Dropdownvalues={["10", "25", "50", "100"]}
        ShowPagination={true}
        ShowPagecount={true}
        tableMinWidth="94vw"
      // showCheckboxes={true}
      />
      {Load && <Loading />}
    </div>
  );
};
export default QBAQuestionStatusTrack;
